// src/App.tsx
import React, { useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import { Box, Tabs, Tab, Button } from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import SettingsIcon from '@mui/icons-material/Settings';
import CustomerTable from './pages/CustomerTable';
import CustomerForm from './pages/CustomerForm';
import LoginPage from './pages/LoginPage';
import api from './api';
import { setNavigator } from './navigation';
import Settings from './pages/Settings';

function VerticalNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const [tabIndex, setTabIndex] = useState(0); 

  useEffect(() => {
    setNavigator(navigate);
  }, [navigate]);

  // const tabIndex = location.pathname.startsWith('/customer/new') ? 1 : 0;
  useEffect(() => {
    if (location.pathname === '/customers') {
      setTabIndex(0);
    } else if (
      location.pathname === '/customer/new' ||
      location.pathname.startsWith('/customers/edit/')
    ) {
      setTabIndex(1);
    } else if (location.pathname === '/settings') {
      setTabIndex(2);
    }
  }, [location.pathname]);

  
  return (
    // This div stays LTR so flex items are "content first, tabs second"
    <Box component="div" dir="ltr" sx={{ display: 'flex', height: '100vh' }}>
      
      {/* Content area: switch back to RTL for all text / inputs */}
      <Box component="div" dir="rtl" sx={{ flexGrow: 1, p: 2 }}>
        {/* <Routes>
          <Route path="/customers" element={<CustomerTable />} />
          <Route path="/customer/new" element={<CustomerForm />} />
          <Route path="/customers/edit/:id" element={<CustomerForm />} />
          <Route path="*" element={<CustomerTable />} />
          <Route path="/login" element={<LoginPage />} />


        </Routes> */}

        <Routes>
          <Route path="/login" element={<LoginPage />} />
          
          <Route
            path="/customers"
            element={
                <CustomerTable />
            }
          />
          <Route
            path="/customer/new"
            element={
                <CustomerForm />
            }
          />
          <Route
            path="/customers/edit/:id"
            element={
                <CustomerForm />
            }
          />
          <Route
            path="*"
            element={
                <CustomerTable />
            }
          />
          <Route path="/settings" element={<Settings />} />
        </Routes>
      </Box>

      {/* Tabs will always render on the right */}
      <Box
  display="flex"
  flexDirection="column"
  justifyContent="space-between"
  sx={{
    borderLeft: 1,
    borderColor: 'divider',
    minWidth: 80,
    py: 2,
  }}
>
  <Tabs
    orientation="vertical"
    value={tabIndex}
    onChange={(_, v) => {
      if (v === 0) navigate('/customers');
      else if (v === 1) navigate('/customer/new');
      else if (v === 2) navigate('/settings');
    }}
    sx={{ minWidth: 80 }}
  >
    <Tab icon={<GroupIcon />} aria-label="customers" />
    <Tab icon={<PersonAddAltIcon />} aria-label="add-customer" />
    <Tab icon={<SettingsIcon />} aria-label="settings" /> 
  </Tabs>

  <Box textAlign="center" px={1}>
  <Button
  variant="contained"
  color="error"
  onClick={async () => {
    try {
      await api.post('/auth/logout'); 
      navigate('/login');
    } catch (err) {
      console.error('Logout failed', err);
    }
  }}
  fullWidth
  sx={{
    fontWeight: 'bold',
    fontSize: '0.85rem',
    borderRadius: 2,
    px: 2,
    py: 1,
    boxShadow: 2,
  }}
>
  התנתקות
</Button>
</Box>

</Box>

    </Box>
  );
}

export default function App() {
  return (
    <Router>
      <VerticalNav />
    </Router>
  );
}
